import React, { useEffect, useState } from 'react';

const PAGE_SIZE = 1; // Number of projects to show per click

const Projects = () => {
  const [projects, setProjects] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [visibleCount, setVisibleCount] = useState(PAGE_SIZE);

  useEffect(() => {
    fetch('/projects.json')
      .then(res => {
        if (!res.ok) throw new Error('Failed to load projects data');
        return res.json();
      })
      .then(setProjects)
      .catch(err => setError(err.message))
      .finally(() => setLoading(false));
  }, []);

  if (loading) return <section className="resume-projects"><p>Loading...</p></section>;
  if (error) return <section className="resume-projects"><p>Error: {error}</p></section>;

  const visibleProjects = projects.slice(0, visibleCount);
  const hasMore = visibleCount < projects.length;

  return (
    <section className="resume-projects">
      <h2>Projects</h2>
      {visibleProjects.map((proj, idx) => (
        <div className="project-item" key={idx}>
          {proj.title && <h3>{proj.title}</h3>}
          {proj.organization && <p><strong>Organization:</strong> {proj.organization}</p>}
          {proj.client && <p><strong>Client:</strong> {proj.client}</p>}
          {proj.role && <p><strong>Role:</strong> {proj.role}</p>}
          {proj.environment && <p><strong>Environment:</strong> {proj.environment}</p>}
          {proj.duration && <p><strong>Duration:</strong> {proj.duration}</p>}
          {proj.description && <p><strong>Description:</strong> {proj.description}</p>}
          {proj.responsibilities && proj.responsibilities.length > 0 && (
            <div>
              <strong>Roles & Responsibilities:</strong>
              <ul>
                {proj.responsibilities.map((resp, rIdx) => (
                  <li key={rIdx}>{resp}</li>
                ))}
              </ul>
            </div>
          )}
        </div>
      ))}
      {hasMore && (
        <div style={{textAlign: 'center', marginTop: '16px'}}>
          <button className="load-more-btn" onClick={() => setVisibleCount(c => c + PAGE_SIZE)}>
            Load More
          </button>
        </div>
      )}
    </section>
  );
};

export default Projects;
